var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { FormattedRelativeTime } from 'react-intl';
import marked from 'marked';
import Money from '../../../../components/Money';
import classNames from 'classnames';
import Icon from '../../../../components/Icon';
import { matchProviderType } from '../../Payment';
import Translate from '../../../../components/Translate';
import { selectUnit } from '@formatjs/intl-utils';

var PaymentAccount = function PaymentAccount(_ref) {
  var account = _ref.account,
      logo = _ref.logo,
      selected = _ref.selected,
      onClick = _ref.onClick,
      onDeleteAccount = _ref.onDeleteAccount;

  var paymentAccountClasses = classNames('payment-method-item-container account', {
    selected: selected
  });

  return React.createElement(
    'div',
    { className: paymentAccountClasses, onClick: onClick },
    logo && React.createElement('div', {
      className: 'provider-logo small',
      style: { backgroundImage: 'url(' + logo + ')' }
    }),
    React.createElement(
      'div',
      { className: 'method-info' },
      React.createElement(
        'div',
        { className: 'method-name' },
        account.maskedAccount
      ),
      React.createElement(
        'div',
        { className: 'method-limit' },
        React.createElement(Translate, {
          id: 'message.last_used',
          defaultMessage: 'message.last_used',
          values: {
            distance: React.createElement(FormattedRelativeTime, selectUnit(new Date(account.lastUsed)))
          }
        })
      )
    ),
    React.createElement(
      'div',
      {
        onClick: function onClick(e) {
          e.stopPropagation();
          onDeleteAccount();
        } },
      React.createElement(Icon, { icon: 'trash' })
    )
  );
};

var PaymentMethodItem = function (_Component) {
  _inherits(PaymentMethodItem, _Component);

  function PaymentMethodItem() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, PaymentMethodItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = PaymentMethodItem.__proto__ || Object.getPrototypeOf(PaymentMethodItem)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
      showDescription: false
    }, _this.toggleDescription = function (e) {
      e.stopPropagation();
      _this.setState(function (state) {
        return {
          showDescription: !state.showDescription
        };
      });
    }, _this.handleSelectAccount = function (account) {
      _this.props.onSelectAccount({
        account: account,
        method: _this.props.method
      });
    }, _this.handleSelectProvider = function () {
      _this.props.onSelectMethod({
        method: _this.props.method
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PaymentMethodItem, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          method = _props.method,
          selectedMethod = _props.selectedMethod,
          selectedAccount = _props.selectedAccount,
          detail = _props.detail,
          currency = _props.currency;
      var showDescription = this.state.showDescription;

      var accounts = method.accounts;

      var providerClassnames = classNames({
        'provider-container': true,
        'show-description': showDescription
      });

      var methodClassnames = classNames('payment-method-item-container', {
        selected: matchProviderType(selectedMethod, method, 'id') && !selectedAccount.accountId
      });

      var toggleIconClassnames = classNames({
        'info-circle': !showDescription,
        times: showDescription
      });

      return React.createElement(
        'div',
        null,
        React.createElement(
          'div',
          { className: providerClassnames },
          React.createElement(
            'div',
            { className: methodClassnames, onClick: this.handleSelectProvider },
            detail.image && React.createElement('div', {
              className: 'provider-logo',
              style: { backgroundImage: 'url(' + detail.image.file.url + ')' }
            }),
            React.createElement(
              'div',
              { className: 'method-info' },
              React.createElement(
                'div',
                { className: 'method-name' },
                detail.title
              ),
              method.limit ? React.createElement(
                'div',
                { className: 'method-limit' },
                React.createElement(Translate, {
                  id: 'noun.min_limit',
                  defaultMessage: 'noun.min_limit',
                  values: {
                    limit: React.createElement(Money, { value: method.limit.min, currency: currency })
                  }
                }),
                ' ',
                React.createElement(Translate, {
                  id: 'noun.max_limit',
                  defaultMessage: 'noun.max_limit',
                  values: {
                    limit: React.createElement(Money, { value: method.limit.max, currency: currency })
                  }
                })
              ) : method.amount ? React.createElement(
                'div',
                { className: 'method-limit' },
                React.createElement(Translate, {
                  id: 'noun.amount',
                  defaultMessage: 'noun.amount',
                  values: {
                    limit: React.createElement(Money, { value: method.amount, currency: currency })
                  }
                })
              ) : null
            ),
            React.createElement(
              'div',
              { onClick: this.toggleDescription },
              React.createElement(Icon, { icon: toggleIconClassnames })
            )
          ),
          React.createElement(
            'div',
            { className: 'provider-description' },
            detail.content && React.createElement('div', {
              dangerouslySetInnerHTML: { __html: marked(detail.content) }
            })
          )
        ),
        accounts && accounts.map(function (account) {
          return React.createElement(PaymentAccount, {
            key: account.accountId,
            logo: detail && detail.image.file.url,
            account: account,
            selected: selectedAccount.accountId === account.accountId,
            onClick: function onClick() {
              return _this2.handleSelectAccount(account);
            },
            onDeleteAccount: function onDeleteAccount() {
              return _this2.props.onDeleteAccount(account);
            }
          });
        })
      );
    }
  }]);

  return PaymentMethodItem;
}(Component);

export default PaymentMethodItem;